import { EntityJournalReactionsPayload, JournalReactionsAppPayload } from "../src/journal_reactions/types";
import {
  easyJournalLoadAllHistory,
  easyJournalLoadMoreHistory,
} from "../src/easy_legacy_js/easy_journals/load_history";
import { handleJournalMenuExpander } from "../src/easy_legacy_js/easy_journals/journal_menu.js";

window.EASY ||= {};
window.EASY.utils ||= {};
window.EASY.utils.easyJournalLoadAllHistory = easyJournalLoadAllHistory;
window.EASY.utils.easyJournalLoadMoreHistory = easyJournalLoadMoreHistory;
window.EASY.utils.handleJournalMenuExpander = handleJournalMenuExpander;

window.EasyVue ||= {};

window.EasyVue.createJournalReactions = async (journalReactionsPayload: JournalReactionsAppPayload) => {
  const { createJournalReactions } = await import("../src/journal_reactions/main");
  createJournalReactions(journalReactionsPayload);
};

window.EasyVue.createEntityJournalsReactions = async (
  entityJournalsReactionsPayload: EntityJournalReactionsPayload
) => {
  const { createEntityJournalsReactions } = await import("../src/journal_reactions/main");
  await createEntityJournalsReactions(entityJournalsReactionsPayload);
};
